import { boogRevision, type BoogMaterial } from './products';

export const boogPlacements = (material: BoogMaterial) => material === 'forex_10mm_double'
  ? ['A', 'B', 'C', 'A-back', 'B-back', 'C-back'] : ['A', 'B', 'C'];

export interface BoogFabricReference { editor: 'fabric'; revision: string; material: BoogMaterial; jsonUrl: string }
export function validBoogFabricReference(value: unknown, material?: BoogMaterial): value is BoogFabricReference {
  if (!value || typeof value !== 'object') return false;
  const v = value as BoogFabricReference;
  return v.editor === 'fabric' && ['multiplex_9mm', 'forex_10mm_double'].includes(v.material)
    && (!material || v.material === material) && v.revision === boogRevision(v.material)
    && typeof v.jsonUrl === 'string' && /^https:\/\/[^/]+\.public\.blob\.vercel-storage\.com\/[^?#]+\.json(?:\?|$)/.test(v.jsonUrl);
}

/** Common 460 mm design canvas; support panels occupy its centred 440 mm crop including bleed. */
export function boogPanelCrop(index: number, canvasWidth: number, canvasHeight: number) {
  const widthMm = index % 3 === 0 ? 460 : 440;
  return { left: (460 - widthMm) / 2 / 460 * canvasWidth, top: 0,
    width: widthMm / 460 * canvasWidth, height: canvasHeight, widthMm, heightMm: 460 };
}

export function boogPlacementJson(json: any, placement: string) {
  return { ...json, objects: (json.objects || []).filter((object: any) =>
    !object.guideType && !object.templateType && object.edgeType !== 'canvas-edge' && !object.studioHidden
    && String(object.designPlacement || 'A') === placement
  ).map((object: any) => ({ ...object, visible: true })) };
}
